'use strict';
// Public Storefront API only. Never add Admin API credentials to this file.
window.DiaStonesShopify = (() => {
  const domain = '81c9s5-m7.myshopify.com';
  const catalog = Object.freeze({
    starter: {handle: 'dia-stones-starter-set', id: 'gid://shopify/Product/15767620452729'}
  });
  const productQuery = `query DiaStonesProduct($handle: String!) @inContext(country: DE, language: DE) {
    product(handle: $handle) {
      id handle title description availableForSale featuredImage { url altText }
      variants(first: 20) { nodes { id title availableForSale price { amount currencyCode } } }
    }
  }`;
  const checkoutMutation = `mutation DiaStonesCheckout($input: CartInput!) @inContext(country: DE, language: DE) {
    cartCreate(input: $input) {
      cart {
        checkoutUrl totalQuantity
        lines(first: 100) { nodes { quantity merchandise { ... on ProductVariant { id } } } }
        cost { subtotalAmount { amount currencyCode } }
      }
      userErrors { field message }
      warnings { code message }
    }
  }`;
  async function request(query, variables) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`https://${domain}/api/2026-10/graphql.json`, {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({query, variables}), signal: controller.signal,
        credentials: 'omit', cache: 'no-store'
      });
      if (!response.ok) throw new Error('Der Shop ist gerade nicht erreichbar. Bitte versuche es gleich noch einmal.');
      const result = await response.json();
      if (result.errors?.length || !result.data) throw new Error('Die Shop-Daten konnten gerade nicht geladen werden.');
      return result.data;
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('Der Shop antwortet gerade nicht. Bitte versuche es gleich noch einmal.');
      throw error;
    } finally { clearTimeout(timeout); }
  }
  async function loadProduct(id) {
    const entry = catalog[id];
    if (!entry) throw new Error('Dieser Schatz ist noch nicht erhältlich.');
    const {product} = await request(productQuery, {handle: entry.handle});
    if (!product || product.id !== entry.id) return null;
    const variant = product.variants.nodes.find(v => v.availableForSale) || product.variants.nodes[0];
    if (!variant || variant.price.currencyCode !== 'EUR') throw new Error('Dieser Artikel kann derzeit nicht in Euro bestellt werden.');
    const price = Math.round(Number(variant.price.amount) * 100);
    if (!Number.isSafeInteger(price) || price < 0) throw new Error('Der Artikelpreis konnte nicht geprüft werden.');
    return {...product, variantId: variant.id, variantTitle: variant.title, price,
      available: product.availableForSale && variant.availableForSale};
  }
  async function cartRequest(endpoint,body){const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);try{const response=await fetch(window.DiaStonesTheme.root+endpoint,{method:body?'POST':'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},body:body?JSON.stringify(body):undefined,credentials:'same-origin',signal:controller.signal,cache:'no-store'});const data=await response.json();if(!response.ok)throw Error(data.description||'Dein Warenkorb konnte gerade nicht aktualisiert werden.');return data;}catch(error){if(error.name==='AbortError')throw Error('Der Shop antwortet gerade nicht. Bitte versuche es erneut.');throw error;}finally{clearTimeout(timeout);}}
  function cartItems(cart){if(cart.currency!=='EUR')throw Error('Dieser Shop zeigt seine Preise in Euro. Bitte prüfe deine Länderauswahl.');return cart.items.map(item=>({id:item.handle==='dia-stones-starter-set'?'starter':'native:'+item.key,qty:item.quantity,key:item.key,native:{name:item.product_title,price:item.final_price,image:item.image||window.DiaStonesTheme.assets['minerals.webp'],subtitle:item.variant_title==='Default Title'?'Amethyst, Rosenquarz & Bergkristall.':item.variant_title||'',shopify:{available:true},type:item.product_type}}));}
  async function readCart(){return cartItems(await cartRequest('cart.js'));}
  async function addItem(variantId){if(!/^gid:\/\/shopify\/ProductVariant\/\d+$/.test(variantId))throw Error('Ungültiger Artikel.');await cartRequest('cart/add.js',{items:[{id:Number(variantId.split('/').pop()),quantity:1}]});return readCart();}
  async function changeItem(key,quantity){if(typeof key!=='string'||!Number.isInteger(quantity)||quantity<0||quantity>20)throw Error('Ungültige Menge.');return cartItems(await cartRequest('cart/change.js',{id:key,quantity}));}
  return Object.freeze({domain,catalog,loadProduct,readCart,addItem,changeItem});
})();
